export const MCP_SCOPE_DESCRIPTIONS: Record<string, string> = {
  "mcp:read": "View Trip and event summaries (required).",
  "mcp:details": "View event details, costs, minimal Trip member references and your personal packing lists.",
  "mcp:write": "Create or update Trips, events, participation, costs and your personal packing lists.",
  "mcp:delete": "Remove Trips, events, participation, costs and packing data after a saved preview and fresh explicit confirmation for each action. Whole-trip deletion permanently deletes one unlocked Trip you own. Requires write access.",
  "offline_access": "Keep the assistant connection active through refresh tokens until you disconnect.",
};

export function describeScopes(scopes: readonly string[]) {
  // Retained refresh families may carry this retired label. It adds no active
  // permission; keep the original grant response intact for connection identity.
  return scopes.filter(scope => scope !== "mcp:trip-delete").map(scope => ({ scope, description: Object.hasOwn(MCP_SCOPE_DESCRIPTIONS, scope) ? MCP_SCOPE_DESCRIPTIONS[scope] : "Permission supplied by the authorization server." }));
}

// Client names are self-asserted. Display the verified/granted identity's origin
// as text; never fetch or navigate to its arbitrary metadata URL.
export function clientOrigin(clientId: string): string | null {
  try {
    const url = new URL(clientId);
    return url.protocol === "https:" && !url.username && !url.password ? url.origin : null;
  } catch { return null; }
}
